import request from "./http";
import qs from 'qs'

// 	 * 统计数据->用电水气看板
export function getElectricity(params) {
    return request({
        url: "/statistics/getElectricity",
        method: "get",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
        params
    });
}

// 	 * 区域能耗->根据(区域Id、应用类型、日期类型、日期)查询能耗
export function getAreaEnergy(params) {
    return request({
        url: "/statistics/getAreaEnergy",
        method: "get",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
        params
    });
}


// 	 * 分项->根据(分项类型、日期类型、日期)查询能耗
export function getSubentryEnergy(params) {
    return request({
        url: "/statistics/getSubentryEnergy",
        method: "get",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
        params
    });
}


// 	 * 区域能耗排名->子区域能耗排名
export function getAreaRanking(params) {
    return request({
        url: "/statistics/getAreaRanking",
        method: "get",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
        params
    });
}

